import { isBeekeeperFeatureEnabled } from '@lumapps/features';
import { hasBeekeeperFormsAccess } from '@lumapps/forms/ducks/selectors';
import { createSelector } from '@lumapps/redux/reselect';

import { BEEKEEPER_SURVEYS } from '../constants';

export const isBeekeeperSurveysEnabled = isBeekeeperFeatureEnabled(BEEKEEPER_SURVEYS);

/**
 * Determines if the current user has access to surveys feature.
 * Access rules:
 * - Must have forms access
 * - Must have BEEKEEPER_SURVEYS feature flag enabled
 */
export const hasBeekeeperSurveysAccess = createSelector(
    hasBeekeeperFormsAccess,
    isBeekeeperSurveysEnabled,
    (hasFormsAccess, hasSurveysEnabled) => {
        return hasFormsAccess && hasSurveysEnabled;
    },
);
